import { render, staticRenderFns } from "./AthleteVerifiedAssessmentsCard.vue?vue&type=template&id=0300260f&scoped=true&"
import script from "./AthleteVerifiedAssessmentsCard.vue?vue&type=script&lang=ts&"
export * from "./AthleteVerifiedAssessmentsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0300260f",
  null
  
)

export default component.exports